import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=b54236aa&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=b54236aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54236aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54236aa')) {
      api.createRecord('b54236aa', component.options)
    } else {
      api.reload('b54236aa', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=b54236aa&scoped=true&", function () {
      api.rerender('b54236aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oi3yHWFNmE2Z/JS/teamMember.vue"
export default component.exports